import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import logo from "../../assets/images/svg/Logo.svg";
import "../../styles/movieLinks.css";

const ANDROID_PACKAGE = "com.prasarbharati.bharat.ott";

const MOVIE_TITLE = "Angad";
const SHARE_URL = "https://www.wavespb.com/links/SH28378nad";
const IOS_STORE_URL = "https://apps.apple.com/in/app/waves-pb/id6478751951";
const ANDROID_STORE_URL =
  "https://www.wavespb.com/links/SH28378nad";

function buildAndroidIntentUrl(shareUrl, androidStoreUrl) {
  const withoutScheme = shareUrl.replace(/^https?:\/\//, "");
  return `intent://${withoutScheme}#Intent;scheme=https;package=${ANDROID_PACKAGE};S.browser_fallback_url=${encodeURIComponent(
    androidStoreUrl,
  )};end`;
}

function detectPlatform() {
  // const ua = navigator.userAgent || navigator.vendor;
  // if (
  //   /iPad|iPhone|iPod/.test(ua) ||
  //   (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  // )
  //   return "ios";
  // if (/android/i.test(ua)) return "android";
  return "desktop";
}

function withRef(url, ref) {
  if (!ref) return url;
  const linked = new URL(url);
  linked.searchParams.set("ref", ref);
  return linked.toString();
}

function buildMovieLinksPageUrl(referralCode) {
  const pageUrl = new URL("/movie-links", window.location.origin);

  if (referralCode) {
    pageUrl.pathname = `/movie-links/${encodeURIComponent(referralCode)}`;
  }

  return pageUrl.toString();
}

function generateQRCode(url) {
  return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(
    url,
  )}`;
}

function AppleIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path
        fill="currentColor"
        d="M17.05 12.82c-.03-2.36 1.93-3.52 2.02-3.57-1.11-1.62-2.82-1.84-3.42-1.86-1.44-.15-2.84.86-3.57.86-.75 0-1.88-.84-3.09-.81-1.57.02-3.04.93-3.85 2.35-1.66 2.88-.42 7.1 1.17 9.43.8 1.14 1.73 2.42 2.94 2.37 1.18-.05 1.62-.76 3.04-.76 1.41 0 1.82.76 3.05.73 1.27-.02 2.07-1.14 2.83-2.29.92-1.31 1.29-2.61 1.3-2.67-.03-.01-2.39-.92-2.42-3.78ZM14.71 5.86c.64-.8 1.08-1.88.96-2.98-.93.04-2.09.64-2.76 1.41-.6.69-1.14 1.82-1 2.87 1.05.08 2.13-.53 2.8-1.3Z"
      />
    </svg>
  );
}

function PlayIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path
        fill="currentColor"
        d="M4.43 3.25a1.7 1.7 0 0 0-.43 1.14v15.22c0 .44.16.84.43 1.14l8.42-8.75-8.42-8.75Zm9.18 7.95 2.56-2.66L6.23 2.86c-.35-.2-.69-.26-.98-.2l8.36 8.54Zm0 1.6-8.36 8.54c.29.06.63 0 .98-.2l9.94-5.68-2.56-2.66Zm3.55 1.83 2.06-1.18c.78-.45.78-1.45 0-1.9l-2.06-1.18-2.88 2.13 2.88 2.13Z"
      />
    </svg>
  );
}

function WebIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
      <path
        stroke="currentColor"
        strokeWidth="2"
        d="M3 12h18M12 3c2.4 2.6 3.8 5.8 3.8 9s-1.4 6.4-3.8 9c-2.4-2.6-3.8-5.8-3.8-9s1.4-6.4 3.8-9Z"
      />
    </svg>
  );
}

export default function MovieLinks() {
  const { referralCode: paramCode } = useParams();
  const [searchParams] = useSearchParams();
  const referralCode =
    paramCode || searchParams.get("ref") || searchParams.get("referral") || "";

  const [platform] = useState(detectPlatform);
  const [currentUrl] = useState(() => buildMovieLinksPageUrl(referralCode));
  const [copied, setCopied] = useState(false);
  const [qrLoaded, setQrLoaded] = useState(false);

  const shareUrl = withRef(SHARE_URL, referralCode);
  const iosStoreUrl = withRef(IOS_STORE_URL, referralCode);
  const androidStoreUrl = withRef(ANDROID_STORE_URL, referralCode);
  const androidIntentUrl = buildAndroidIntentUrl(shareUrl, androidStoreUrl);

  // Platform is detected synchronously on first render (lazy initializer),
  // so the correct view — QR on desktop, redirect UI on mobile — paints
  // immediately with no loading flash. The auto-open attempt is still a
  // side effect, so it runs post-paint via useEffect rather than blocking
  // the initial render.
  useEffect(() => {
    if (platform === "ios") {
      window.location.href = shareUrl;
    } else if (platform === "android") {
      window.location.href = androidIntentUrl;
    }
  }, [platform, shareUrl, androidIntentUrl]);

  const handleCopy = () => {
    navigator.clipboard?.writeText(referralCode).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <section className="movie-links-page ">
      <div className="movie-links-wrap">
        <div className="movie-links-card">
          <span className="movie-links-logo-badge">
            <img src={logo} alt="HKI Media" className="movie-links-logo" />
          </span>
          <p className="movie-links-eyebrow ff_n">Now Streaming on Waves PB</p>
          <h1 className="movie-links-title ff_s">
            Watch <span>{MOVIE_TITLE}</span> on your phone
          </h1>
          <p className="movie-links-desc ff_n">
            Yamuna Putra Angad is streaming now on Waves PB. Continue to
            start watching.
          </p>

          {referralCode && (
            <div className="movie-links-referral">
              <div>
                <span>Referral Code</span>
                <strong>{referralCode}</strong>
              </div>
              <button type="button" onClick={handleCopy}>
                {copied ? "Copied" : "Copy"}
              </button>
            </div>
          )}

          {platform === "desktop" ? (
            <>
              <div className="movie-links-qr">
                {!qrLoaded && <span className="movie-links-spinner" />}
                <img
                  src={generateQRCode(SHARE_URL)}
                  alt="Scan to open this page on your phone"
                  onLoad={() => setQrLoaded(true)}
                  style={qrLoaded ? {} : { display: "none" }}
                />
              </div>
              <p className="movie-links-note ff_n">
                Scan this code with your phone to watch {MOVIE_TITLE}.
              </p>
            </>
          ) : (
            <div className="movie-links-redirect">
              <span className="movie-links-spinner" />
              <p className="ff_n">Taking you to {MOVIE_TITLE}…</p>
              <a
                href={platform === "android" ? androidIntentUrl : shareUrl}
                className="movie-links-fallback ff_n"
              >
                Click here if it doesn&apos;t open automatically
              </a>
            </div>
          )}

          <div className="movie-links-divider">
            <span />
            Download Now
            <span />
          </div>

          <div className="movie-links-store-row">
            <a href={iosStoreUrl} target="_blank" rel="noopener noreferrer">
              <AppleIcon />
              <span>App Store</span>
            </a>
            <a href={androidStoreUrl} target="_blank" rel="noopener noreferrer">
              <PlayIcon />
              <span>Google Play</span>
            </a>
            <a href={shareUrl} target="_blank" rel="noopener noreferrer">
              <WebIcon />
              <span>Watch on Web</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
